import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppPages } from '@app/app.pages';
import { AuthService } from '@app/services/auth/auth.service';
import { AuthState } from '@app/enums/auth-state.enum';
import { Observable, map } from 'rxjs';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    return authService.authState.pipe(
        map((authState: AuthState) => {
            console.log('🚀 ~ map ~ authState:', authState);
            if (authState === AuthState.IsNotAuthenticated) {
                return router.parseUrl(AppPages.LOGIN);
            }
            return true;
        })
    );
};
